export default "__VITE_ASSET__cf40c8a1__"